import { Record } from 'immutable';
class EscalationReason extends Record({
  id: 0,
  description: '',
  type: null
}, 'EscalationReason') {}
EscalationReason.fromJS = obj => new EscalationReason(Object.assign({}, obj));
export default EscalationReason;